var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',{attrs:{"prop":_vm.prop,"label":_vm.label,"width":_vm.width,"min-width":_vm.minWidth,"align":_vm.align,"sortable":_vm.sortable,"formatter":_vm.formatter,"fixed":_vm.fixed}})}
var staticRenderFns = []

export { render, staticRenderFns }